import { useQuery } from "react-query";
import DashboardApiClient from "api/DashboardApiClient";

export function useMapData(sportType, sex, sportTrainingLevel) {
    return useQuery(["mapData", { sportType, sex, sportTrainingLevel }], () =>
        DashboardApiClient.getMapData(sportType, sex, sportTrainingLevel),
    );
}
